// The standard DataTables reskin, one instance per table. Every selector is scoped to the wrapper
// DataTables hands back on `settings.nTableWrapper`, or to the element this instance was built
// with, so a page can carry more than one table without them cross-wiring.
export default class LassoDataTable {
  constructor(element, params) {
    this.initialize(element, params)
  }

  initialize(element, params) {
    const fnDrawCallback = (settings) => {
      const $wrapper = $(settings.nTableWrapper)

      // Style the pagination buttons
      $wrapper.find(".paginate_button.first a, .paginate_button.last a").addClass("btn btn-main btn-ghost")

      const $pages = $wrapper.find(".paginate_button:not(.previous, .next, .first, .last)")

      // Only set the classes if there's more than one page, so the ellipsis shows only then
      if ($pages.length > 1) {
        $pages.first().addClass("first-page")
        $pages.last().addClass("last-page")
      }

      $wrapper.find(".paginate_button.previous a").html("<i class='icon-lasso-chevron-left'></i>")
      $wrapper.find(".paginate_button.next a").html("<i class='icon-lasso-chevron-right'></i>")

      // Hide the pagination if there's only one page
      if (settings._iDisplayLength > settings.fnRecordsDisplay()) {
        $wrapper.find(".dataTables_paginate").hide()
      } else {
        $wrapper.find(".dataTables_paginate").show()
      }

      const url = new URL(window.location.href)
      $wrapper.find("#" + url.searchParams.get("id")).closest("tr").addClass("highlighted")

      if (params["fnDrawCallback"]) {
        params["fnDrawCallback"](settings)
      }
    }

    /* Sets a typing delay on the provided text input field */
    const typingDelay = (callback, ms) => {
      let timer = 0
      return function() {
        const context = this, args = arguments
        clearTimeout(timer)
        timer = setTimeout(() => {
          callback.apply(context, args)
        }, ms || 0)
      }
    }

    const setDelayInput = (element) => {
      if (element.length === 0) {
        return
      }

      element.
        closest(".dataTables_wrapper").
        find(".dataTables_filter input[type='search'], .search-bar input.datatable-search").
        unbind().
        bind("input", (typingDelay((event) => {
          element.
            DataTable().
            search($(event.currentTarget).val()).
            draw()
          return
        }, 500)))
    }

    const defaultParams = {
      "processing": true,
      "serverSide": true,
      "responsive": false,
      "autoWidth": false,
      "lengthMenu": [25, 50, 75, 100, 500, 1000],
      "pageLength": 25,
      "dom": "<'dataTable_container'tr>" +
        "<'table-information'p<'page-information'li>>",
      "pagingType": "full_numbers",
      "language": {
        search: "",
        emptyTable: "No data available.",
        searchPlaceholder: "Search by name or email",
        lengthMenu: "Show _MENU_",
        info: "viewing _START_ - _END_ / _TOTAL_",
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Prev"
        }
      },
      "ajax": {
        "url": element.data("source"),
      },
    }

    this.dataTable = element.dataTable({...defaultParams, ...params, "fnDrawCallback": fnDrawCallback})
    setDelayInput(element)
  }

  totalLength() {
    return this.dataTable.api().settings()[0].fnRecordsTotal()
  }

  filteredLength() {
    return this.dataTable.api().settings()[0].fnRecordsDisplay()
  }

  pageLength() {
    return this.dataTable.api().page.info().length
  }

  currentPageNumber() {
    return this.dataTable.api().page.info().page
  }

  searchTerm() {
    return this.dataTable.api().search()
  }

  destroy() {
    this.dataTable.DataTable().destroy()
  }
}
